import { SmartTable } from '../../../../../components/smart-table/smart-table.model';
import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $scope,
        Alert) {
		this.$state = $state;
		this.$scope = $scope;
		this.Alert = Alert;
		this.st= new SmartTable();
		console.log(this);
	}
	
	  $onInit() {
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(()=>{
                this.Alert('success', 'global.data_copied')
            })
        })
		console.log(this);
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/sharing-center-reports/sharing-center-deleted-report/sharing-center-deleted-report.controller.js